import { useState, useEffect } from "react"

export function useWaitIndicator(timeout: number) {
    const [showWaitIndicator, setShowWaitIndicator] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setShowWaitIndicator(true), timeout)

        return () => clearTimeout(timer)
    }, [timeout])

    return { showWaitIndicator }
}
